import { useRef, ReactNode } from 'react';
import classes from './header.module.scss';

type THeaderProps = {
  logo?: ReactNode;
  leftSection?: ReactNode;
  rightSection?: ReactNode;
  banner?:ReactNode;
};
export const Header = ({ logo, leftSection, rightSection , banner }: THeaderProps) => {
  const headerRef = useRef<HTMLInputElement>(null);
  return (
    <div>
    <div className={classes.header} ref={headerRef}>
      <div className={classes.sectionOne}>
        <div>{logo}</div>
        <div>{leftSection}</div>
      </div>
      <div className={classes.sectionTwo}>{rightSection}</div>
    </div>
    {banner && <div className={classes.banner}>{banner}</div>}
    </div>
  );
};
